export class NotaFiscalViewModel {
    cod_chave_acesso: string;
    des_municipio: string;
    dtc_emissao: Date;
    dtc_recepcao_origem: Date;
    nom_razao_social: string;
    nota_Participante: string;
    num_cnpj_base_emi: string;
    num_nota_fiscal: number;
    seq_consumidor: number;
    val_total: string;

    cod_modelo_nota_fiscal: number;

    linkEspelhoNota: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/model/nota-fiscal.viewmodel.ts